import { Text } from '@chakra-ui/react'

export default function CustomFormFieldErrorMessage({ message }: { message?: string }) {
  if (!message) return null
  return (
    <Text color="danger" fontSize="md">
      {message}
    </Text>
  )
}
